import { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import Spinner from "../../components/Spinner";
import { loadAppointment } from "../../api-helpers/appointmentWorkflow";
import { appointmentDetailsPath } from "../../constants/Appointment";

/**
 * Legacy /schedule/charting/:appointmentId. Appointment details now live under
 * the patient profile; this keeps every existing link working (schedule, the
 * overlay's saved detailsPath, bookmarks) by looking up the appointment's patient
 * and replacing the URL.
 */
export const AppointmentRedirect = () => {
  const { appointmentId } = useParams();
  const [target, setTarget] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!appointmentId) return;
    let cancelled = false;
    loadAppointment(appointmentId)
      .then((appointment) => {
        if (cancelled) return;
        const patientId = appointment.patients?.[0]?.patientId;
        if (patientId) {
          setTarget(appointmentDetailsPath(appointmentId, patientId));
        } else {
          setFailed(true);
        }
      })
      .catch(() => !cancelled && setFailed(true));
    return () => {
      cancelled = true;
    };
  }, [appointmentId]);

  if (target) return <Navigate to={target} replace />;
  if (failed || !appointmentId) return <Navigate to="/schedule" replace />;
  return <Spinner />;
};
